"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/FileMessage/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);










var _RichMessageWrapper = require('web/components/Conversation/Message/RichMessageWrapper'); var _RichMessageWrapper2 = _interopRequireDefault(_RichMessageWrapper);
var _fetcher = require('web/services/fetcher'); var _fetcher2 = _interopRequireDefault(_fetcher);
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);



var _previewSupport = require('shared/utils/previewSupport');
var _message = require('shared/enum/message');
var _uploadProgress = require('shared/services/uploadProgress');

var _FilePlain = require('./FilePlain'); var _FilePlain2 = _interopRequireDefault(_FilePlain);
var _FileImage = require('./FileImage'); var _FileImage2 = _interopRequireDefault(_FileImage);
var _CanceledNotice = require('./CanceledNotice'); var _CanceledNotice2 = _interopRequireDefault(_CanceledNotice);
var _MediaTile = require('./MediaTile'); var _MediaTile2 = _interopRequireDefault(_MediaTile);
var _FileVideo = require('./FileVideo'); var _FileVideo2 = _interopRequireDefault(_FileVideo);
var _useFileOpener = require('./useFileOpener'); var _useFileOpener2 = _interopRequireDefault(_useFileOpener);
var _useFileDownload = require('./useFileDownload'); var _useFileDownload2 = _interopRequireDefault(_useFileDownload);
var _CaptionPart = require('./CaptionPart'); var _CaptionPart2 = _interopRequireDefault(_CaptionPart);



















































const FileMessage = ({
  fileReference,
  fileName,
  fileSize,
  fileMime = '',
  blurHash,
  imageWidth,
  imageHeight,
  thumbnailUrl,
  durationMs,
  onRetry,
  onAbort,
  caption,
  onReplyCaption,
  ...baseMessageProps
}) => {
  const {
    deleted,
    deliveryStatus,
    senderKey,
    currentUserKey,
    messageKey,
  } = baseMessageProps
  const isFromMe = senderKey === currentUserKey
  const isFromThem = !isFromMe
  const isPending = deliveryStatus !== _message.deliveryStatus.DELIVERED
  const uploadProgress = _uploadProgress.useUploadProgress.call(void 0, isFromMe && isPending ? messageKey : undefined)
  const uploadLabel = _uploadProgress.uploadStatusLabel.call(void 0, uploadProgress)
  const failureLabel = deliveryStatus === _message.deliveryStatus.FAILED
    ? _uploadProgress.uploadFailureLabel.call(void 0, _optionalChain([uploadProgress, 'optionalAccess', _ => _.failure]))
    : undefined
  const canRetry = _optionalChain([uploadProgress, 'optionalAccess', _2 => _2.phase]) !== 'failed' || uploadProgress.retryable
  const { download, downloadNode } = _useFileDownload2.default.call(void 0, currentUserKey)
  const canDownload = !deleted && !!fileReference && deliveryStatus === _message.deliveryStatus.DELIVERED
  const handleSaveFile = _react.useMemo.call(void 0, 
    () => canDownload ? () => download(fileReference) : null,
    [canDownload, download, fileReference],
  )
  const { openFile, fallbackNode } = _useFileOpener2.default.call(void 0, handleSaveFile)

  const captionPart = _CaptionPart.useCaptionPart.call(void 0, caption, deleted, onReplyCaption)

  const getFileLinks = _react.useCallback.call(void 0, 
    () => fileReference
      ? _fetcher2.default.call(void 0, '/get_file_link?key=' + fileReference, 'GET', null)
        .catch(() => null)
      : Promise.resolve(null),
    [fileReference],
  )

  const requestOriginal = _react.useCallback.call(void 0, 
    () => getFileLinks().then(response => _optionalChain([response, 'optionalAccess', _3 => _3.Link]) || null),
    [getFileLinks],
  )
  const requestFreshThumbnail = _react.useCallback.call(void 0, 
    () => getFileLinks().then(response => _optionalChain([response, 'optionalAccess', _4 => _4.ThumbnailLink]) || null),
    [getFileLinks],
  )
  const handleDownload = _react.useCallback.call(void 0, 
    () => openFile(requestOriginal),
    [openFile, requestOriginal],
  )
  const handleRetry = _react.useCallback.call(void 0, 
    () => onRetry(messageKey, fileReference),
    [messageKey, fileReference, onRetry],
  )
  const handleAbort = _react.useCallback.call(void 0, 
    () => onAbort(messageKey, { pruneTimeout: 1200 }),
    [messageKey, onAbort],
  )

  const mediaKind = _react.useMemo.call(void 0, 
    () => _previewSupport.getMimeFirstMediaKind.call(void 0, fileMime, fileName),
    [fileMime, fileName],
  )
  const isCanceled = deliveryStatus === _message.deliveryStatus.CANCELED
  const renderImageDerivative = _previewSupport.shouldRenderImageDerivative.call(void 0, {
    blurHash,
    imageWidth,
    imageHeight,
    thumbnailUrl,
  })

  const rootClassName = _react.useMemo.call(void 0, 
    () => deleted
      ? _classBuilder2.default.call(void 0, 
        "text-message",
        isFromMe && "text-message--me",
        isFromThem && "text-message--them",
      )
      : _classBuilder2.default.call(void 0, 
        "file-message",
        isFromMe && "file-message--me",
        isFromThem && "file-message--them",
        isCanceled && "file-message--canceled",
        caption && "file-message--captioned",
      )
    , [deleted, isFromMe, isFromThem, isCanceled, caption],
  )

  return (
    _react2.default.createElement(_RichMessageWrapper2.default, {
      ...baseMessageProps,
      onRetry: handleRetry,
      onDownload: handleSaveFile,
      uploadLabel: uploadLabel,
      failureLabel: failureLabel,
      canRetry: canRetry,
      part: captionPart, __self: this, __source: {fileName: _jsxFileName, lineNumber: 182}}

      , _react2.default.createElement('div', { className: rootClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 191}}
        ,  deleted
          ? _react2.default.createElement('div', { className: "message--deleted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 193}}, "This file was recalled"   )
          : mediaKind === 'image'
            ? renderImageDerivative
              ? _react2.default.createElement(_FileImage2.default, {
                key: fileReference,
                fileName: fileName,
                thumbnailUrl: thumbnailUrl,
                blurHash: blurHash,
                imageWidth: imageWidth,
                imageHeight: imageHeight,
                onRequestFreshThumbnail: requestFreshThumbnail,
                onRequestOriginal: requestOriginal,
                onDownloadOriginal: handleSaveFile,
                onRetry: handleRetry,
                onAbort: handleAbort,
                deliveryStatus: deliveryStatus,
                canRetry: canRetry, __self: this, __source: {fileName: _jsxFileName, lineNumber: 196}}
              )
              : _react2.default.createElement(_MediaTile2.default, { kind: "image", fileName: fileName, onClick: handleDownload, __self: this, __source: {fileName: _jsxFileName, lineNumber: 211}} )
            : mediaKind === 'video'
              ? renderImageDerivative
                ? _react2.default.createElement(_FileVideo2.default, {
                  key: fileReference,
                  blurHash: blurHash,
                  thumbnailUrl: thumbnailUrl,
                  imageWidth: imageWidth,
                  imageHeight: imageHeight,
                  fileName: fileName,
                  durationMs: durationMs,
                  onRequestFreshThumbnail: requestFreshThumbnail,
                  onRequestOriginal: requestOriginal,
                  onDownloadOriginal: handleSaveFile, __self: this, __source: {fileName: _jsxFileName, lineNumber: 214}}
                )
                : _react2.default.createElement(_MediaTile2.default, { kind: "video", fileName: fileName, onClick: handleDownload, __self: this, __source: {fileName: _jsxFileName, lineNumber: 226}} )
              : _react2.default.createElement(_FilePlain2.default, {
                fileName: fileName,
                fileSize: fileSize,
                onDownload: handleDownload,
                onRetry: handleRetry,
                onAbort: handleAbort,
                deliveryStatus: deliveryStatus,
                canRetry: canRetry, __self: this, __source: {fileName: _jsxFileName, lineNumber: 227}}
              )
        
        ,  caption && !deleted && (
          _react2.default.createElement(_CaptionPart2.default, {
            caption: caption,
            className: "file-message__caption",
            currentUserKey: baseMessageProps.currentUserKey,
            subscribers: baseMessageProps.subscribers,
            conversationKey: baseMessageProps.conversationKey,
            onAddReaction: baseMessageProps.onAddReaction,
            onRemoveReaction: baseMessageProps.onRemoveReaction,
            readOnly: baseMessageProps.readOnly, __self: this, __source: {fileName: _jsxFileName, lineNumber: 238}}
          )
        )
        ,  isCanceled && _react2.default.createElement(_CanceledNotice2.default, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 249}} ) 
      )
      , fallbackNode
      , downloadNode
    )
  )
}

exports. default = FileMessage
